import React, { Component, Fragment } from "react";
import DataTable from 'react-data-table-component';
import {
  Form,
  Input,
  Button,
  Radio,
  DatePicker,
  notification
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';
import locale from 'antd/lib/locale/th_TH';

class TeamSub extends Component {
  constructor(props) {
    super(props);
    this.state = {
        factUpdate: false,
        LangTranslate: [[]],
        title: "TEAM",
        companyID: Number(Cookies.get("companyid")),
        operatorID: Number(Cookies.get("operator_id")),
        projectID: Number(Cookies.get("project_id")),
        actionTeamSub: "ADD",
        actionTeamSubText: "SAVE",
        TeamDisplay: "none",
        teamGroupIDAdd: 0,
        teamIDAdd: 0,
        teamSubNameAdd: "",
        tlEmployeeIDAdd: 0,
        statusAdd: 1,
        EffectiveDateAdd: moment().toDate(),
        ExpiryDateAdd: "",
        EffectiveDateAddFilter: moment().toDate(),

        active: ["","Active","Inactive"],
        teamGroupType: [],
        MessageDisplay:"none",
        message: "",
        teamID: 0,
        filterDataList: [],
        filterDataListTeamGroup: [],
        where: "",
        filterDataListEmployee: [],
        fillEffectiveDateDisplay: "none",
    };
  }
  notify = (type, title, msg) => {
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  };
  async componentDidMount() {
    console.log(moment().toDate());
      this.onCallTeamSub();
      const data_team_group_type_get = await Api.post("get_team_group_type_selection", {
        company_id: Number(Cookies.get("companyid")),
        operator_id: Number(Cookies.get("operator_id")),
        project_id: Number(Cookies.get("project_id"))
      });
      this.setState({teamGroupType:data_team_group_type_get.data.data.team_group_list});
      this.onCallEmployee();
  }
  onCallTeamSub = () => {
    this.state.filterDataList = [];

    Api.post("get_team_sub_group", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      team_name: ""
    }).then((res)=> {
      let tmp = [];
      res.data.data.team_sub_list.map((item, index) => (
          tmp.push({
            "teamID": item.team_id,
            "teamSubName": <div title={item.team_name}>{item.team_name}</div>,
            "effectiveDate": this.displayDate(item.effective_date),
            "expiredDate": this.displayDate(item.expire_date),
            "status":
            <div>
              {item.is_active === 0 ? (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span>InActive
                </span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>,
            "action": <button onClick={()=> this.onClickEditTeamSub(item.company_id,item.operator_id,item.project_id,item.team_group_id,item.team_id,item.team_name,item.tl_employee_id,item.is_active,item.effective_date,item.expire_date)} id={"btnEdit"+index} className="text-primary"><img src={Api.absoluteUrl("/icon/edit.svg")}></img></button>
            })
          ));
          this.setState({ filterDataList: tmp});
          });
  }

  onChangeEffectiveDate = (date, dateString) =>{
    this.setState({
      EffectiveDateAdd: dateString,
      EffectiveDateAddFilter: dateString
    })
  }

  onChangeExpiryDate = (date, dateString) => {
    this.setState({
      ExpiryDateAdd: dateString
    })
  }

  onCallTeamGroup = () =>{
    this.state.filterDataListTeamGroup = [];
    Api.post("get_team_group", {
      pk_id: null,
      is_active: 2,
      effective: null,
      sql_where: " and operator_id = "+Cookies.get("operator_id")+" and project_id = " + Cookies.get("project_id"),
      company_id: Cookies.get("companyid"),
    })
    .then((res) => {
      this.setState({ filterDataListTeamGroup: res.data.data.team_group_list});
    })
  }

  onCallEmployee = () => {
    this.state.filterDataListEmployee = [];
    Api.post("/get_employee", {
      "pk_id": null,
      "is_active": 1,
      "effective": null,
      "sql_where": ""
    })
    .then((res) =>{
      this.setState({filterDataListEmployee:res.data.data});
    });
  }

  onCloseTeamWindow = () =>{
      this.setState({
        TeamDisplay: "none",
      jobTypeAdd: "",
      teamGroupTypeAdd: "",
      teamSubNameAdd: ""})
  }

  displayDate  = (data) => {
    if(data != null){
      const day = data.substring(0,10).split("-");
      return day[2] + "/" + day[1] + "/" + day[0];
    }
    return "-";
  }

  setStatus = (event) => {
    this.setState({statusAdd:event.target.value})
    console.log('statusAdd:'+event.target.value);
  }

  setTeamOfType = (event) =>{
    this.setState({teamOfTypeAdd:event.target.value});
    console.log('teamOfType:'+event.target.value);
  }

  setTeamGroupType = (event) => {
    this.setState({teamGroupTypeAdd:event.target.value})
    console.log('teamGroupType:'+event.target.value);
  }
  setTeamGroupName = (event) => {
    this.setState({teamSubNameAdd:event.target.value})
    console.log('teamSubNameAdd:'+event.target.value);
  }

  ClickActionTeamSub = (e) => {
    e.preventDefault();

    if(this.state.EffectiveDateAdd == ""){
      this.notify("info", "Informaton", "Please select Effective Date before.");
      e.stopPropagation();
    }else{

      let apiAddress ="ins_team_sub";
      if (this.state.actionTeamSub == "EDIT") {
        apiAddress ="upd_team_sub";
      }else{
        this.state.teamIDAdd = 0;
        this.state.EffectiveDateAdd = moment(this.state.EffectiveDateAdd).format("YYYY-MM-DD");
      }

      Api.post(apiAddress, {
        company_id: Number(Cookies.get("companyid")),
        operator_id: Number(Cookies.get("operator_id")),
        project_id: Number(Cookies.get("project_id")),
        team_group_id : this.state.teamGroupIDAdd,
        team_id: this.state.teamIDAdd,
        team_name : this.state.teamSubNameAdd,
        tl_employee_id : this.state.tlEmployeeIDAdd,
        is_active: this.state.statusAdd,
        effective_date : (this.state.EffectiveDateAdd) != ''? this.state.EffectiveDateAdd:null,
        expire_date : (this.state.ExpiryDateAdd) != ''? this.state.ExpiryDateAdd:null,
        create_by : Cookies.get("userId"),
        update_by : Cookies.get("userId")
      })
      .then((res) => {
        const { result} = res.data;
            if (result.value === "P") {
              this.setState({teamSubNameAdd:""});
              let msg = "เพิ่มข้อมูลเรียบร้อยแล้วค่ะ";
              if (this.state.actionTeamSub == "EDIT") {
                msg = "บันทึกข้อมูลเรียบร้อยแล้วค่ะ";
              }
              this.setState({TeamDisplay:"none",MessageDisplay:"block", message:msg});
              msg = "";
            }
      })
      .catch((e) => {
        console.log("error action team sub", e);
        this.setState({MessageDisplay:"block", message:e.message});
      });
      this.onCallTeamSub();
      e.stopPropagation();
    }
  }

  onClickEditTeamSub = (company_id,operator_id,project_id,team_group_id,team_id,team_name,tl_employee_id,is_active,effective_date,expire_date) => {
    window.scrollTo(0, 0);
    this.onCallTeamGroup();
    console.log('expire:'+expire_date);
    this.setState({actionTeamSub:"EDIT",TeamDisplay:"block",teamGroupIDAdd:team_group_id,teamIDAdd:team_id,teamSubNameAdd:team_name,tlEmployeeIDAdd:tl_employee_id,statusAdd:is_active,EffectiveDateAdd: effective_date,EffectiveDateAddFilter:effective_date,ExpiryDateAdd: (expire_date != "")? expire_date: null});
  }

  onCallCloseMessageWindow = () =>{
    this.setState({MessageDisplay:"none"});
  }

  search = (e) =>{
    Api.post("get_team_sub_group", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      team_name: e.target.value
    })
    .then((res) => {
      this.state.filterDataList = [];
      let tmp = [];
      res.data.data.team_sub_list.map((item, index) => (
        tmp.push({
          "teamID": item.team_id,
          "teamSubName": <div title={item.team_name}>{item.team_name}</div>,
          "effectiveDate": this.displayDate(item.effective_date),
          "expiredDate": this.displayDate(item.expire_date),
          "status":
          <div>
            {item.is_active === 2 ? (
              <span className="c-red">
                <span className="dot-Inactive mr-2"></span>InActive
              </span>
            ) : (
              <span className="c-green">
                <span className="dot-active mr-2"></span>Active
              </span>
            )}
          </div>,
          "action": <button onClick={()=> this.clickEditTeamSub(item.company_id,item.operator_id,item.project_id,item.team_group_id,item.team_id,item.team_name,item.tl_employee_id,item.is_active,item.effective_date,item.expire_date)} id={"btnEdit"+index} className="text-primary"><img src={Api.absoluteUrl("/icon/edit.svg")}></img></button>
          })
        ));
        this.setState({ filterDataList: tmp});
        tmp = [];

    })

  }

  TeamAction = (action) => {
    this.onCallTeamGroup();
    if(action == "add"){
        this.setState({TeamDisplay:"block",actionTeamSub:"ADD"});
    }
  }

  setTeamGroup = (event) => {
    this.setState({teamGroupIDAdd: event.target.value});
  }

  setEmployee = (event) => {
    this.setState({tlEmployeeIDAdd: event.target.value});
  }

  setTeamSubName = (event) => {
    this.setState({teamSubNameAdd: event.target.value});
  }

  render() {
      const columns = [
        {
            name: `Team ID`,
            selector: 'teamID',
            sortable: true
        },
        {
            name: "Team Sub Name",
          selector: 'teamSubName',
          sortable: true
        },
        {
          name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
          selector: 'effectiveDate',
          sortable: true,
        },
        {
          name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
          selector: 'expiredDate',
          sortable: true,
        },
        {
          name: "Status",
          selector: 'status',
          sortable: true
        },
        {
            name: "Action",
            selector: 'action',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            style: 'cursor:pointer'
        },
      ];


    return (
    <div>
        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">Team Sub</h3>

        <div className="d-flex justify-content-between my-3">
        <Input.Search
            placeholder="Search by Name"
            style={{ width: 200 }}
            onChange={(e)=>this.search(e)}
        />

        <button
            className="btn btn-warning"
            onClick={() => this.TeamAction("add")}
        >
            <img src={Api.absoluteUrl("/icon/plus.svg")} className="mr-2" />
            Add Team Sub
        </button>
        </div>


        <DataTable
            columns={columns}
            data={this.state.filterDataList}
            pagination={false}
            highlightOnHover
        />

        <div id="AddTeamWindow" className="add-new-window" style={{
            position: 'absolute', top: '20%',
            left: '50%',
            marginLeft: '-260px',
            display: this.state.TeamDisplay
        }}>
            <form className="needs-validation" onSubmit={this.ClickActionTeamSub}>
                <div>
                    <div className="header-add-problem-type-window">{this.state.actionTeamSub} {this.state.title}</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{`Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group 
                        id="statusAdd"
                        name="statusAdd" 
                        value={this.state.statusAdd}
                        onChange={this.setStatus}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row2 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Team Group</div>
                        <div>
                        <select
                            id="JobType"
                            className="dropdrowtype select-problem-type set-width-200 form-select"
                            onChange={(e)=>this.setTeamGroup(e)}
                            value={this.state.teamGroupIDAdd}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT TEAM GROUP</option>
                            {this.state.filterDataListTeamGroup.map((item, index) => (
                              <option value={item.team_group_id} key={`layout_b_${index}`}>
                              {item.team_group_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>TL EMPLOYEE</div>
                        <div>
                        <select
                            id="JobType"
                            className="dropdrowtype select-problem-type set-width-200 form-select"
                            onChange={(e)=>this.setEmployee(e)}
                            value={this.state.tlEmployeeIDAdd}
                            required
                          >
                            <option value={0} className="please-select">PLEASE KEY USERNAME</option>
                            {this.state.filterDataListEmployee.map((item, index) => (
                              <option value={item.emp_id} key={`layout_b_${index}`}>
                              {item.emp_code+" "+item.emp_name}
                              </option>
                            ))}
                            </select>
                        </div>
                      </div>
                    </div>

                    {/*row3*/}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>Team Sub Name</div>
                        <div>
                        <input maxLength={165} onChange={(e)=>this.setTeamSubName(e)} value={this.state.teamSubNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    {/* row4 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDate} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):null} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div>
                          <DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDate}  value={(this.state.ExpiryDateAdd != null)? moment(this.state.ExpiryDateAdd, this.state.dateFormat):null} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateAddFilter)} /></div>
                      </div>
                    </div>
                    {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={this.onCloseTeamWindow}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit"  className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;{this.state.actionTeamSubText}&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                </div>
            </form>
        </div>

        <div id="MessageWindow" className="confirm-window" style={{
                  position: 'absolute', left: '50%', top: '20%',
                  transform: 'translate(-50%, -20%)',
                  display: this.state.MessageDisplay
              }}>
          <div className="row">
            <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
              {this.state.message}
            </div>
          </div>
          <div className="row row-add">
            <div className="col-sm-12 m-0 p-0 text-center">
              <Button type="primary" onClick={this.onCallCloseMessageWindow}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>
            </div>
          </div>
        </div>

    </div>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(TeamSub);

